import { selectPlaygroundPlaceId } from 'containers/Playground/playgroundSlice'
import { addNotification } from 'containers/Notifications/notificationsSlice'
import useObjectHover from 'containers/Playground/hooks/useObjectHover'
import { selectPlaceColors } from 'containers/MapDetails/placeSlice'
import { selectUserId } from 'containers/Login/loginSlice'
import { useReduxDispatch, useReduxSelector } from 'store'
import { useHistory, useParams } from 'react-router-dom'
import type { SelectedObjects } from './WarehouseList'
import useTranslation from 'hooks/useTranslation'
import WarehouseNotes from './WarehouseNotes'
import { selectLightTheme } from 'appSlice'
import React from 'react'

interface WarehouseProps extends playground.Warehouse {
  isChildren?: boolean
  selectedObjects: SelectedObjects
}

const Warehouse: React.FC<WarehouseProps> = ({ isChildren = false, selectedObjects, ...mag }) => {
  const { id, blink, children, name, color_state, /* note, */ rotation, x, y, width, height, style, door, doorLock, typeId, warehouseData: wd } = mag

  const clientId = useReduxSelector(selectUserId)
  const colors = useReduxSelector(selectPlaceColors)
  const lightTheme = useReduxSelector(selectLightTheme)
  const placeId = useReduxSelector(selectPlaygroundPlaceId)
  const params = useParams<{ id: string }>()

  const isSelected = params.id === typeId
  const magMainRef = React.useRef<HTMLDivElement>(null)

  const dispatch = useReduxDispatch()
  const { t } = useTranslation('placeMap')
  const { replace, push, goBack } = useHistory()
  const onHover = useObjectHover(magMainRef, mag.hover)


  const displayAlert = (message: string) => {
    dispatch(addNotification({ message, type: 'danger' }))
  }

  const textStyle: React.CSSProperties | undefined = rotation ? { rotate: `${-rotation}deg` } : undefined

  return (
    <div
      id={`object_${id}`}
      className='object'
      style={{
        left: x,
        top: y,
      }}>
      <div
        ref={magMainRef}
        className={`object__main${isSelected ? ' --selected' : ''}${blink ? ' --blink' : ''}`}
        onMouseEnter={onHover}
        onClick={() => {
          if (!children) {
            if (!wd?.status?.isAvailableForRent
              || !!wd?.status?.inTemporaryReservation
              || color_state?.includes('muted')) {
              displayAlert(t(
                color_state?.includes('purple')
                  ? 'youAreAlreadyRentingThisWarehouse'
                  : wd?.status?.inTemporaryReservation
                    ? 'warehouseIsCurrentlyBeingRented'
                    : !wd?.status?.isAvailableForRent
                      ? 'warehouseIsUnavailable'
                      : 'warehouseDoesNotMeetTheSelectedFilters'
              ))
              return
            }

            if (isSelected) {
              goBack()
            } else {
              const action = params.id ? replace : push
              action(`/placemap/${placeId}/${typeId}`)
            }
          }
        }}
        style={(() => {
          const base: React.CSSProperties = {
            width: `${width}px`,
            height: `${height}px`,
            rotate: `${rotation}deg`,
            flexDirection: height < 80 ? 'row' : 'column'
          }

          if (!color_state?.includes('purple')) {
            if ((color_state === 'normal' && lightTheme) || (color_state?.includes('muted') && !lightTheme)) {
              base.backgroundColor = 'rgba(152, 152, 152, 0.1)'
              base.borderColor = 'rgba(122, 122, 122, 1)'
              base.color = 'rgba(122, 122, 122, 1)'
            } else {
              base.backgroundColor = 'rgba(216, 216, 216, 0.1)'
              base.borderColor = 'rgba(216, 216, 216, 1)'
              base.color = 'rgba(216, 216, 216, 1)'
            }
          }

          if (isSelected) {
            base.backgroundColor = 'rgba(235, 0, 61, 0.25)'
            base.borderColor = 'rgba(235, 0, 61, 1)'
            base.color = 'rgba(235, 0, 61, 1)'
          } else if (selectedObjects[typeId]) {
            base.backgroundColor = 'rgba(135, 132, 227, 0.25)'
            base.borderColor = 'rgba(135, 132, 227, 1)'
          } else if (color_state?.includes('purple')) {
            base.opacity = '1'
          }
          return { ...style, ...base }
        })()}>
        {children ? children.map((e, i) => <Warehouse
          {...e}
          key={i}
          isChildren
          selectedObjects={selectedObjects} />
        ) : <>
          <div
            className='object__name'
            style={textStyle}>
            {name}
          </div>
          {/* {note === '5 minut' && <WarehouseTimer
            endTime={Date.now() + (5 * 60 * 1000)}
            style={textStyle}
          />} */}
          {(height > 80 && (
            (wd?.status?.isAvailableForRent || clientId === wd?.renting?.clientId) ||
            (clientId && wd?.renting?.clientId ? clientId === wd?.renting?.clientId : true)
          )) && <WarehouseNotes
              {...mag}
              style={textStyle} />}
          {true
            ? (wd?.status?.isAvailableForRent || clientId === wd?.renting?.clientId)
              ? <div
                className='object__color'
                style={colors && wd?.hash ? { backgroundColor: colors[wd.hash] } : undefined} />
              : null
            : <div className={`object__entrance${height < 80 ? ' --rotated' : ''}`}>
              <div className='entrance__lock' style={doorLock} />
              <div className='entrance__door' style={door} />
            </div>}
        </>}
      </div>
    </div>
  )
}

export default Warehouse